import { render, staticRenderFns } from "./DhmeWkbInspectionPlanRisksDetail.vue?vue&type=template&id=95c0a3e0&scoped=true"
import script from "./DhmeWkbInspectionPlanRisksDetail.vue?vue&type=script&lang=js"
export * from "./DhmeWkbInspectionPlanRisksDetail.vue?vue&type=script&lang=js"
import style0 from "./DhmeWkbInspectionPlanRisksDetail.vue?vue&type=style&index=0&id=95c0a3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c0a3e0",
  null
  
)

export default component.exports